import {
    companyUserStatusIconClass,
    companyUserStatusLabel,
    companyUserStatusTextClass
} from './sp-user-status.exports';

export class Controller {

    $onChanges() {
        this.tooltipKey = companyUserStatusLabel(this.status, this.blockedStatus);
        this.iconClass = companyUserStatusIconClass(this.status, this.blockedStatus);
        this.textClass = companyUserStatusTextClass(this.status, this.blockedStatus);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-user-status/sp-user-status.controller.js